import { PageTitle } from '@/components';
import { useCreateBlogPost } from '@/services/mutations/blog';
import { useNavigate } from 'react-router-dom';
import { BlogPostForm } from './components/BlogPostForm';

const CreateBlogPost = () => {
	const navigate = useNavigate();
	const onBack = () => navigate('/admin/blog');

	const { mutate, isPending } = useCreateBlogPost(onBack);

	const onSubmit = (body: Blog.CreateBlogPost) => mutate(body);

	return (
		<section className="space-y-4 px-4 py-8">
			<PageTitle text="Blog" />
			<BlogPostForm
				formTitle="Criar novo post"
				onBack={onBack}
				onSubmit={onSubmit}
				isSubmitting={isPending}
			/>
		</section>
	);
};

export { CreateBlogPost };
